import * as Actions from '../../actions/payment';


const initialState={
    data: {
        cards : []
    },
    isLoading: false,
    isLoaded : false,
    error: false
};

const payment = function (state = initialState, action) {
    switch (action.type) {
      
            
        case Actions.LIST_CARDS: case Actions.SAVE_CARD :{
            return {
                ...state,
                isLoading: true,
                isLoaded : false,
                error: false
            };
        }
        case Actions.LIST_CARDS_SUCCESS: case Actions.SAVE_CARD_SUCCESS :{
            let newData=state.data


            if(Array.isArray(action.payload.outbound.rawData)) 
                newData.cards = action.payload.outbound.rawData
            else
                newData.cards = [action.payload.outbound.rawData]
                
            return {
                ...state,
                data: newData,
                isLoading: false,
                isLoaded : true,
                error: false
            };
        }
        case Actions.LIST_CARDS_ERROR: case Actions.SAVE_CARD_ERROR: {
            return {
                ...state,
                isLoading: false,
                isLoaded : false,
                error: action.error
            };
        }
 
        case Actions.REMOVE_CARD:{
            return {
                ...state,
                isLoading: true,
                isLoaded : false,
                error: false
            };
        }
        case Actions.REMOVE_CARD_SUCCESS: {
            let newData=state.data

            console.log(action.payload)
            

            if(action.payload) {
                newData.cards = state.data.cards.filter(c => c.KK_GUID!==action.payload)
            }
            
            return {
                ...state,
                data: newData,
                isLoading: false,
                isLoaded : true,
                error: false
            };
        }
        case Actions.REMOVE_CARD_ERROR:{
            return {
                ...state,
                isLoading: false,
                isLoaded : false,
                error: action.error
            };
        }
            

        default: {
            return state;
        }
    }
};

export default payment